import React from 'react';
import { Box } from '@mui/material';
import BugReportIcon from '@mui/icons-material/BugReport';
import ReviewsIcon from '@mui/icons-material/Reviews';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { pagePaths } from 'routes/paths';
import { feedbackActions } from 'features/feedback/store/feedback.slice';
import { FeedbackType } from 'features/feedback/shared/feedback.types';

const OPTIONS: Array<{
  type: FeedbackType; icon: React.ReactNode; title: string; desc: string; color: string; bg: string;
}> = [
  { type: 'BUG', icon: <BugReportIcon />, title: 'Баг', desc: 'Щось працює не так', color: '#E2330A', bg: 'rgba(226,51,10,.10)' },
  { type: 'REVIEW', icon: <ReviewsIcon />, title: 'Відгук', desc: 'Загальне враження про застосунок', color: '#3B2C93', bg: 'rgba(59,44,147,.10)' },
  { type: 'IDEA', icon: <LightbulbIcon />, title: 'Ідея', desc: 'Пропозиція покращення — публічна', color: '#12a596', bg: 'rgba(39,204,188,.14)' },
];

const TypePicker: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const isAdmin = useAppSelector((s) => s.admin.isAdmin);
  const goIdeas = () => {
    dispatch(feedbackActions.closeDrawer());
    navigate(`/${pagePaths.feedbackIdeas}`);
  };
  const go = (path: string) => {
    dispatch(feedbackActions.closeDrawer());
    navigate(`/${path}`);
  };
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
      {OPTIONS.map((o) => (
        <Box
          key={o.type}
          role="button"
          aria-label={o.title}
          onClick={() => dispatch(feedbackActions.pickType(o.type))}
          tabIndex={0}
          onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); dispatch(feedbackActions.pickType(o.type)); } }}
          sx={{
            display: 'flex', alignItems: 'center', gap: 1.5, p: 1.5, cursor: 'pointer',
            border: '1px solid #E7E7E7', borderRadius: '12px',
            '&:hover': { background: 'rgba(59,44,147,.04)' },
          }}
        >
          <Box sx={{ width: 44, height: 44, borderRadius: '10px', display: 'grid', placeItems: 'center', background: o.bg, color: o.color }}>
            {o.icon}
          </Box>
          <Box sx={{ flex: 1 }}>
            <Box sx={{ fontSize: 16, fontWeight: 700 }}>{o.title}</Box>
            <Box sx={{ fontSize: 13, color: '#7A7F88' }}>{o.desc}</Box>
          </Box>
          <ChevronRightIcon sx={{ color: '#BBBFC7' }} />
        </Box>
      ))}
      <Box
        role="button"
        tabIndex={0}
        onClick={goIdeas}
        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); goIdeas(); } }}
        sx={{ mt: 1, fontSize: 14, fontWeight: 600, color: '#12897d', cursor: 'pointer', textAlign: 'center' }}
      >
        Дивитись усі ідеї спільноти →
      </Box>
      <Box
        role="button"
        tabIndex={0}
        onClick={() => go(pagePaths.feedbackMine)}
        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(pagePaths.feedbackMine); } }}
        sx={{ mt: 0.5, fontSize: 14, fontWeight: 600, color: '#3B2C93', cursor: 'pointer', textAlign: 'center' }}
      >
        Мої звернення →
      </Box>
      {isAdmin && (
        <Box
          role="button"
          tabIndex={0}
          onClick={() => go(pagePaths.adminFeedback)}
          onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(pagePaths.adminFeedback); } }}
          sx={{ mt: 0.5, fontSize: 14, fontWeight: 600, color: '#7A7F88', cursor: 'pointer', textAlign: 'center' }}
        >
          Тріаж звернень (адмін) →
        </Box>
      )}
    </Box>
  );
};

export default TypePicker;
